(() => {
  const paymentMethods = document.querySelector('.payment');
  const target = document.querySelector('.payment-methods');

  if (paymentMethods && target) {
    target.appendChild(paymentMethods.cloneNode(true));
  }
})();
